export const SiteRoute = {
  Home: '/',
  CompanyNotFound: '/company-not-found',
  LeaseSigning: '/lease-signing',
  LeaseSigningSuccess: '/lease-signing/success',
  LeaseSigningExpired: '/lease-signing/expired',
  RentalApplications: '/rental-applications',
  RentalApplicationGetStarted: '/rental-applications/get-started',
} as const;
